import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconExclamationCircleBold: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconExclamationCircleBold"><Circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><Path d="M11.3121 12.3511L11.0582 7.9983C11.0266 7.45662 11.4574 7 12 7C12.5426 7 12.9734 7.45662 12.9418 7.9983L12.6879 12.3511C12.6666 12.7154 12.365 13 12 13C11.635 13 11.3334 12.7154 11.3121 12.3511Z" fill="currentColor"/><Circle cx="11.9999" cy="15.8998" r="1.1" fill="currentColor"/></CentralIconBase>;
});

export default IconExclamationCircleBold;
